import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { messagesApi } from '../api/messages';
import { useToastStore } from '../stores/toastStore';

export function useInbox(enabled = true) {
  return useQuery({
    queryKey: ['messages', 'inbox'],
    queryFn: () => messagesApi.getInbox().then((res) => res.data.data),
    staleTime: 15000,
    enabled,
  });
}

export function useOutbox() {
  return useQuery({
    queryKey: ['messages', 'outbox'],
    queryFn: () => messagesApi.getOutbox().then((res) => res.data.data),
    staleTime: 15000,
  });
}

export function useMarkRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (messageId: string) => messagesApi.markRead(messageId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['messages', 'inbox'] });
    },
  });
}

export function useReplyMessage() {
  const queryClient = useQueryClient();
  const addToast = useToastStore((s) => s.addToast);

  return useMutation({
    mutationFn: ({ messageId, templateKey, customText }: { messageId: string; templateKey: string; customText?: string }) =>
      messagesApi.reply(messageId, templateKey, customText).then((res) => res.data.data.message),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['messages'] });
      queryClient.invalidateQueries({ queryKey: ['stars', 'map'] });
      addToast(`Reply launched! Arrives in ${data.travelDays} day${data.travelDays !== 1 ? 's' : ''}.`, 'success');
    },
    onError: (error: any) => {
      const msg = error.response?.data?.error?.message || 'Reply failed';
      addToast(msg, 'error');
    },
  });
}
